import { cn } from '@/lib/utils';
import { FC, useCallback } from 'react';
import { List, Orderable } from '../../../modifiers/Orderable';
import { InputProps, withField } from '../../withField';
import { TextInput } from '../TextInput';

interface MultiTextInputProps {
  placeholder?: string;
}

export const MultiTextInput: FC<InputProps<string[]> & MultiTextInputProps> = ({
  onChange,
  value = [],
  id,
  placeholder
}) => {
  const onReorder = useCallback(
    (source: number, destination: number) => {
      const array = [...value];
      const [removed] = array.splice(source, 1);
      array.splice(destination, 0, removed);
      onChange(array);
    },
    [onChange, value]
  );

  const onDelete = useCallback(
    (id: string) => {
      const array = value.filter(item => item !== id);
      onChange(array);
    },
    [onChange, value]
  );

  const onChangeItem = useCallback(
    (index: number) => (input: string) => {
      const array = [...value];
      array[index] = input;
      onChange(array);
    },
    [onChange, value]
  );

  const onAdd = useCallback(
    (input: string) => {
      const array = [...value];
      array.push(input);
      onChange(array);
    },
    [onChange, value]
  );

  return (
    <>
      <List
        id="droppable"
        itemIds={value}
        className={cn(value.length > 0 && `mb-2 -mt-3`)}
        onReorder={onReorder}
        onDelete={onDelete}
      >
        {value.map((item, index) => (
          <Orderable className="mt-2" key={`multiTextInput-${index}`} id={item} index={index}>
            <TextInput
              id={`${id}-${index}`}
              value={item}
              autofocus={index === value.length - 1}
              onChange={onChangeItem(index)}
            />
          </Orderable>
        ))}
      </List>
      <div className="opacity-75">
        <TextInput id={`${id}-add`} value="" placeholder={placeholder} onChange={onAdd} />
      </div>
    </>
  );
};

export const MultiTextField = withField<string[], MultiTextInputProps>(MultiTextInput);
